import { QueryKey, useQueryWrapper } from "./api-hooks-common";
import { EasasJsVersionsApi } from "../EasasJsVersionsApi";

export const useEasasJsVersions = () =>
  useQueryWrapper([QueryKey.EASASJS_BUILDS], () => EasasJsVersionsApi.getBuilds());
